import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../utils/alert";

const defaultPlatform = (platform, id = '') => ({
    platform,
    id,
    apk: '',
    version: '',
    build_number: '',
    min_build_number: '',
    force_update: false,
    download_url: '',
    release_notes: '',
});

export const defaultFormValues = {
    android: defaultPlatform('android', ''),
    ios: defaultPlatform('ios', ''),
};

const parseForceUpdate = (value) =>
    value === true || value === 1 || value === '1' || value === 'true';

export const mapAppVersionResponse = (list) => {
    const next = {
        android: defaultPlatform('android'),
        ios: defaultPlatform('ios'),
    };
    if (!Array.isArray(list)) {
        return next;
    }
    list.forEach((item) => {
        const key = String(item?.platform || '').toLowerCase();
        if (key !== 'android' && key !== 'ios') return;
        next[key] = {
            platform: key,
            id: item?.id ?? '',
            apk: '',
            version: item?.version ?? '',
            build_number: item?.build_number ?? '',
            min_build_number: item?.min_build_number ?? '',
            force_update: parseForceUpdate(item?.force_update),
            download_url: item?.download_url ?? '',
            release_notes: item?.release_notes ?? '',
        };
    });
    return next;
};

export const appVersionList = createAsyncThunk('appVersionList', async ({ navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `app-version`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const appVersionListSlice = createSlice({
    name: 'appVersionList',
    initialState: {
        data: [],
        formValues: defaultFormValues,
    },
    extraReducers: (builder) => {
        builder.addCase(appVersionList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const list = action.payload.data?.data ?? action.payload.data;
                state.data = Array.isArray(list) ? list : [];
                state.formValues = mapAppVersionResponse(state.data);
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            }
        });
    }
})

export default appVersionListSlice.reducer;
